import { useEffect } from 'react';
import { useAppDispatch } from '../../../../redux/hooks';
import { llmSetCachedRawData } from '../../../../redux/slices/llm';
import { LlmSubjectKind } from '../../../../utils/apollo/graphqlSchema';
import { MaybeNil } from '../../../../utils/interfaces';

interface IProps {
  analysisId: string;
  rawData: MaybeNil<string>;
  skip?: boolean;
}

export const objectToKvPairs = (obj: any): string => {
  return Object.keys(obj)
    .map((k) => {
      const v = obj[k];
      return `${k}=${v}`;
    })
    .join(', ');
};

const useCacheLlmRawDataEffect = ({ analysisId, rawData, skip }: IProps) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (skip) {
      return;
    }
    dispatch(
      llmSetCachedRawData({
        subjectKind: LlmSubjectKind.Analysis,
        subjectId: analysisId,
        rawData: !!rawData ? rawData : null,
      }),
    );
  }, [dispatch, analysisId, rawData, skip]);
};

export default useCacheLlmRawDataEffect;
